export var DefaultConditionalTypesEnum = /*#__PURE__*/function (DefaultConditionalTypesEnum) {
  DefaultConditionalTypesEnum["BEGINS_WITH"] = "BEGINS_WITH";
  DefaultConditionalTypesEnum["CONTAINS"] = "CONTAINS";
  DefaultConditionalTypesEnum["ENDS_WITH"] = "ENDS_WITH";
  DefaultConditionalTypesEnum["EQUAL_TO"] = "EQUAL_TO";
  DefaultConditionalTypesEnum["NOT_CONTAINS"] = "NOT_CONTAINS";
  DefaultConditionalTypesEnum["NOT_EQUAL_TO"] = "NOT_EQUAL_TO";
  DefaultConditionalTypesEnum["RANGE"] = "RANGE";
  return DefaultConditionalTypesEnum;
}({});